/*
  import { parkingList } from '@/services/AccountSettings/ParkingSpaces/list'
*/

import Vue from 'vue'
import Vuex from 'vuex'
import _get from 'lodash/get'

import { notifyProblem, notifyError, notifyMessage } from '@/services/notify'
import kms from '@/services/kms'

const isDebug = true

/* eslint-disable no-empty-pattern */
const actions = {
  /*
    const { list } = await parkingList.dispatch ('getParkingList', {
      hoaId
    });
  */
  async getParkingList({}, { hoaId }) {
    if (isDebug == true) console.debug('in getParkingList...')
    try {
      const result = await kms.get('/ParkingSpaces/ParkingSpace/List', {
        params: {
          hoaId
        }
      })

      if (isDebug == true) console.debug('getParkingList log=' + JSON.stringify(result))

      return {
        list: result.results
      }
    } catch (exception) {
      notifyProblem(`The parking space list could not be retrieved.`)
      console.error(exception)
    }

    return {
      list: []
    }
  },

  async deleteParking({ dispatch }, { parkingSpaceID, done }) {
    try {
      const path = `/ParkingSpaces/ParkingSpace/${parkingSpaceID}?forceDelete=false`

      const results = await kms.delete(path)

      if (isDebug == true) console.debug('results=' + JSON.stringify(results))

      if (dispatch && dispatch != undefined) console.debug(dispatch)

      const wasDeleted = _get(results, 'deleted', false)

      if (wasDeleted === true) {
        notifyMessage(`Successfully deleted this parking space.`)
        done()
      } else {
        notifyError('There was a problem deleting this parking space.')
      }
    } catch (exception) {
      notifyProblem(`There was a problem deleting this parking space.`)
      console.error(exception)
    }
  }
}
/* eslint-enable no-empty-pattern */

Vue.use(Vuex)
export const parkingList = new Vuex.Store({
  state: {},
  mutations: {},
  getters: {},
  actions
})
